import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import SharedUserDrawer, { DRAWER_WIDTH_LG, DRAWER_WIDTH_XL } from './SharedUserDrawer';
import { useSelector, useDispatch } from "react-redux" 
import { Button } from '@material-ui/core';
import logo5 from "../logo5.png"
import RehabPlanMainComponent from './data/overview_data.js/RehabPlanMainComponent'
import TreatmentSessionPlayer from './treatmentSession/treatmentSessionPlayer';
import Treatmentadvices from './data/treatmentadvice/Treatmentadvice.js';
import recoveryPhases from '../user_dashboard/data/recoveryPhases';
import * as AuthActions from "../../store/actions/auth";
import ReactPlayer from 'react-player'
import RehabPhases from "./data/rehabPhases.js";
import RehabPhaseTracker from './data/overview_data.js/RehabPhaseTracker';
import { PatientHeaderContent } from '../../Landingpagecomponents/Header/headerPatient.js';
import { useHistory } from "react-router-dom";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Virtus Physio | Your Virtual Physiotherapist
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

//logout
  //
  //

const drawerWidth = 178;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100vh',
  },
  toolbar: {
    paddingRight: 24,
    minHeight: '50px !important',
    maxHeight: 50,
    [theme.breakpoints.up('xl')]: {
      minHeight: '57px !important',
      maxHeight: 57,
    },
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 50,
    maxHeight: 50,
    boxShadow: '0 2px 4px rgba(40,40,40,0.22), 0 2px 6px rgba(40,40,40,0.28)',
    [theme.breakpoints.up('xl')]: {
      height: 57,
      maxHeight: 57,
    },
  },
  responsiveLogo: {
    marginTop: 0,
    maxWidth: 200,
    minWidth: 165,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 120,
      minWidth: 165,
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: 200,
      minWidth: 165,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 200,
      minWidth: 165,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 250,
      minWidth: 165,
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 250,
      minWidth: 165,
    },
  },
  appBarShift: {
    marginLeft: DRAWER_WIDTH_LG,
    width: `calc(100% - ${DRAWER_WIDTH_LG}px)`,
    [theme.breakpoints.up('xl')]: {
      marginLeft: DRAWER_WIDTH_XL,
      width: `calc(100% - ${DRAWER_WIDTH_XL}px)`,
    },
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarSpacer: { 
    ...theme.mixins.toolbar,
    marginBottom: 0
  },
  content: {
    flexGrow: 1,
    maxWidth: "100%",
    height: '100vh',
    overflow: 'auto',
    backgroundColor: "#F5F5F5",
  },
  container: {
    height: '80%', width: 'auto',
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  containerEmbedded: {
    paddingTop: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(4),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
}));

export default function Overview() {
  const token = useSelector(state => state.auth.token);
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
  const embeddedWorkspace = typeof window !== 'undefined'
    && new URLSearchParams(window.location.search).get('embedded') === '1';
  const [selectedTreatmentId, setSelectedTreatmentId] = useState(null);
  const [treatments, setTreatments] = useState([]);

  const dispatch = useDispatch();
  const history = useHistory();

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  // Fetch treatments on mount
  useEffect(() => {
    const fetchTreatments = async () => {
      if (!token) return;
      console.log('[Physiotherapeutic_plan] Fetching treatments...');
      try {
        const res = await fetch('https://api.virtus-one.com/treatment/user/treatments/', {
          method: 'GET',
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
          },
        });
        if (res.ok) {
          const data = await res.json();
          console.log('[Physiotherapeutic_plan] Treatments fetched:', data);
          setTreatments(data);
          
          // Restore from localStorage or use first treatment
          const savedTreatmentId = localStorage.getItem('vp_selectedTreatmentId');
          if (savedTreatmentId && data.find(t => t.id === savedTreatmentId)) {
            setSelectedTreatmentId(savedTreatmentId);
          } else if (data.length > 0) {
            setSelectedTreatmentId(data[0].id);
          }
        }
      } catch (error) {
        console.error('[Physiotherapeutic_plan] Error fetching treatments:', error);
      }
    };
    fetchTreatments();
  }, [token]);

  const handleClickLogout = async () => { 
    console.log('[LOGOUT_HANDLER] handleClickLogout called');
    try {
      console.log('[LOGOUT_HANDLER] Dispatching logout action...');
      await dispatch(AuthActions.logout());
      console.log('[LOGOUT_HANDLER] Logout action completed, redirecting...');
    } catch (e) {
      console.error('[LOGOUT_HANDLER] Error during logout:', e);
      dispatch({type: AuthActions.LOGOUT});
    }
    console.log('[LOGOUT_HANDLER] Redirecting to home...');
    window.location.replace("/");
  };

  const handleTreatmentChange = (treatment) => {
    console.log('[Physiotherapeutic_plan] Treatment changed to:', treatment.id);
    setSelectedTreatmentId(treatment.id);
    localStorage.setItem('vp_selectedTreatmentId', treatment.id);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  // Secure check: redirect if not logged in or no token (AFTER all hooks)
  if (!isLoggedIn || !token) {
    window.location.replace("/");
    return <div>Redirecting to login...</div>;
  }
  
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  return (
    <div className={classes.root}>
      <CssBaseline />
      {!embeddedWorkspace ? (
        <>
          <AppBar style={{ color: "#002D55", backgroundColor: "#FFFFFF" }} position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
            <Toolbar className={classes.toolbar}>
              <PatientHeaderContent 
                onLogout={handleClickLogout} 
                onProfile={() => history.push('/myaccount?tab=profile')} 
                onOpenVideo={() => {}} 
                onOpenCheckin={() => {}} 
                onTreatmentChange={handleTreatmentChange}
              />
            </Toolbar>
          </AppBar>
          <SharedUserDrawer open={open} onOpen={handleDrawerOpen} onClose={handleDrawerClose} />
        </>
      ) : null}
     
      <main className={classes.content} style={{background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)'}}> 
        {!embeddedWorkspace ? <div className={classes.appBarSpacer} /> : null}
          <Grid key={selectedTreatmentId} container className={clsx(classes.container, embeddedWorkspace && classes.containerEmbedded)} style={{background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)', marginBottom: "22%"}}>
            <Grid item xs={12} >
              {/*<TreatmentSessionPlayer drawerOpen={open} setDrawerOpen={setOpen} />*/}
              <RehabPlanMainComponent 
                drawerOpen={open} 
                setDrawerOpen={setOpen} 
                treatmentId={selectedTreatmentId}
              />
            </Grid>
            <Grid item xs={12} style={{ margin: "0.7%" }}>
              <Copyright />
            </Grid>
        </Grid>
          
      </main>
    </div>
  );
}
